import propTypes, { string } from 'prop-types'
import styled from 'styled-components'
import React from 'react'
import { ButtonBase } from '@material-ui/core'

const Title = styled.div`
  font-size: 2.3em;
  color: var(--first);
  font-family: 'imlbold'; font-weight: bold;
  line-height: 1em;
  margin-bottom: .3em;
`
const Content = styled.div`
  margin-bottom: 1em;
`
const Subtitle = styled.div`
  font-size: 1.5em;
  font-family: 'imlmedium';
  color: var(--first);
  line-height: 1em;
`

export const SectionHeader = props => {
  return (
    <Content id='headersteped'>
      <Title>{props.title}</Title>
      <Subtitle>{props.subtitle}</Subtitle>
    </Content>
  )
}

SectionHeader.propTypes = {
  title: string,
  subtitle: string
}

/** FooterWidthButtons */
const ContainerFotterButtons = styled.div`
  display: flex;
  justify-content: ${props => props.$justify || 'flex-end'};
  align-items: center;
`
const ButtonBack = styled(ButtonBase)`
  font-size: 1em;
  color: #666666;
  background-color: #cccccc;
  padding: .4em 1.8em;
  font-size: 1.1em;
  margin-right: 1em;
  border-radius: 50px;
  :last-of-type {
    margin-right: 0px;
  }
`
const ButtonConfirm = styled(ButtonBack)`
  background-color: var(--first);
  color: #fff;
`
export const FotterWidthButtons = props => {
  return (
    <ContainerFotterButtons $justify={props.justify}>
      {!props.hideBack && (
        <ButtonBack onClick={props.onBack}>
          Regresar
        </ButtonBack>
      )}
      {!props.hideConfirm && (
        <ButtonConfirm onClick={props.onConfirm}>
          Confirmar
        </ButtonConfirm>
      )}
    </ContainerFotterButtons>
  )
}

FotterWidthButtons.propTypes = {
  justify: propTypes.string,
  onConfirm: propTypes.func,
  onBack: propTypes.func,
  hideConfirm: propTypes.bool,
  hideBack: propTypes.bool
}
